<template>
  <div class="page">
    <div class="list">
      <ul class="first-list">
        <template v-for="(menu, index) in slicedItems">
          <router-link v-if="!menu.disable" :key="index" :to="menu.url">
            <li v-if="!menu.disable" :key="index" class="link" :class="{ 'selected-menu': currentRoute.startsWith(menu.url) }" @click="handleClick($event, menu)">
                <span>{{ menu.label }}</span>
                <img v-if="menu.img" :src="menu.img">
                <img v-if="menu.img" :src="menu.img">
            </li>
        </router-link>
        </template>
      </ul>
      <ul class="second-list">
        <template v-for="(menu, index) in nextSlicedItems">
          <router-link v-if="!menu.disable" :key="index" :to="menu.url"  :target="menu.label === 'FileNet' ? '_blank' : '_self'" @click="handleClick($event, menu)">
            <li v-if="!menu.disable" :key="index" class="link" :class="{ 'selected-menu': menu.url === currentRoute }">
                <span>{{ menu.label }}</span>
                <img v-if="menu.img" :src="menu.img">
            </li>
          </router-link>
        </template>
      </ul>
      <ul class="third-list">
        <template v-for="(menu, index) in furtherSlicedItems">
          <router-link v-if="!menu.disable" :key="index" :to="menu.url">
            <li v-if="!menu.disable" :key="index" class="link" :class="{ 'selected-menu': menu.url === currentRoute } " @click="handleClick($event, menu)">
                <span>{{ menu.label }}</span>
                <img v-if="menu.img" :src="menu.img">
            </li>
          </router-link>
        </template>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator'
import { inject } from 'inversify-props'
import { isEmpty } from 'lodash/fp'
import { IProjectSettings } from '@master/config/IProjectSettings'
import { SharedVariable } from '@core/model/SharedVariable';
import { UIService } from '@core/services/UIService'
import { FilenetConfigurationService } from '@core/openapi/services/filenet-configuration/api';
import { ability } from '@core/services/CaslAbility'; 

@Component({
  emits:['closePopup']
})
export default class Admin extends Vue {
  @inject()
  private projectSettings: IProjectSettings

  @inject()
  private sharedVariable: SharedVariable;
  
  uiService: UIService
  private isEnabledTenantConfig:boolean = false

  fileNetURL : string = ''

  get currentRoute() {
    return this.$route.path
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get useTenantConfig () {
    return this.isEnabledTenantConfig
  }

  get currentAllPermissions() {
    return this.$store.getters.currentAllPermission
  }

  get isTenantConfigDisabled () {
    // using action as "read" for existance
    return this.sharedVariable.isPermissionDisabled("tenantConfiguration", "read", this.currentAllPermissions)
  }

  get isQualificationSetupDisabled () {
    return this.sharedVariable.isPermissionDisabled("qualificationsSetup", "read", this.currentAllPermissions)
  }

  get slicedItems() {
		return this.menus.slice(0, 11);
	}

  get nextSlicedItems () {
		return this.menus.slice(11, 22);
  }
  get furtherSlicedItems () {
		return this.menus.slice(22, 33);
  }
  get windowHeight () {
    return this.window.innerHeight;
  }

  async fetchActiveFileNetURL() {
  try {
    const res = await FilenetConfigurationService.getActiveFilenetUrl();
    // Check if filenet_url exists and is a non-empty string
    if (!isEmpty(res?.data?.filenet_url)) {
      this.fileNetURL = res.data.filenet_url;
    } else {
      // If filenet_url is invalid or empty, set fileNetURL to an empty string
      this.fileNetURL = '';  // Make sure fileNetURL is defined as an empty string
    }
  } catch (error) {
    this.uiService.alert.show({
      type: 'error',
      message: error
    });
  }
  }

  handleClick(event,menu) {
      // Check if the URL is external (not part of Vue Router)
      if (menu?.label?.toLowerCase()=== 'filenet') {
        // Prevent Vue Router from handling the navigation
        event.preventDefault();
        // Open the external URL in a new tab
        window.open(menu.url, '_blank'); 
      }

      this.$emit('closePopup');
  }
  
  mounted(){
     this.uiService = this.sharedVariable.uiService
     if (!(['adviser', 'supervisor', 'director'].includes(this.currentUser?.systemRole))){
     this.fetchActiveFileNetURL()
     }
  }

  get menus() {
  const menu =  ['adviser', 'supervisor', 'director'].includes(this.currentUser.systemRole) ?
      [
        {
          label: 'Resources',
          url: '/resources',
          // subjects: ['resources'],
          disable: !this.projectSettings.useResourcesModule
        }
      ] : [
        {
          label: 'Adviser Sales Code Update',
          url: '/adviser-sales-code-update',
        },
        {
          label: 'Assumptions List',
          url: '/admin-assumptions',
          disable: !this.projectSettings.useAssumptionsList
        },
        {
        url: '/audit-log',
        label: 'Audit Log',
        component: () => import('@core/pages/auditLog/components/AuditLog.vue'),
        subjects: ['auditLogs']
        },
        {
          url: '/approvals',
          label: 'Approvals',
          component: () => import('@core/pages/approvals/components/Approvals.vue')
        },
        {
          label: 'Balanced Scorecard (BSC) Setup',
          url: '/bsc-setup',
          subjects: [
            'bscAdviserGrade',
            'bscReportSetup',
            'bscSupervisorGrade',
            'bscVariablePercentage',
          ],
        },
        {
          label: 'Balanced Scorecard (BSC) Grading',
          url: '/bsc-grading/',
          subjects: [
            'bscAgentFinding',
            'bscBaseRecord',
            'bscCycleExecution',
            'bscGradeImportSummary',
            'bscAdviserProfile',
            'bscSupervisorVarIncome',
            'bscAdviserVarIncome',
            'bscAdversePolicy',
            'bscCommissionClawback'
          ],
        },
        {
          label: 'Branch and Manager Administration',
          url: '/group-list',
          // img: require('@core/assets/admin/Group Administration.png')
        },
        {
          url: '/commission/',
          label: 'Commissions',
          img: ''
        },
        // {
        //   url: '/commission-module/',
        //   label: 'Commission Module',
        //   img: ''
        // },
        {
          label: 'Compensation & Production Bonus Setup',
          url: '/compensation-setup',
          // img: require('@core/assets/admin/Product Principal List.png')
        },
        {
          label: 'Continuing Professional Development(CPD)',
          url: '/cpd/summary',
          subjects: ['cpdTraining'],
          // img: require('@core/assets/admin/CPD.png')
        },
        {
          label: 'Country Master',
          url: '/country-master',
          disable: '',
          subjects: ['country'],
        },
        {
          label: 'Data Load',
          url: '/data-load',
          subjects: ['dataLoad']
        },
        {
          label: 'DiSign',
          url: '/disign-panel',
          img: '',
          disable: ''
        },
        {
          label: 'Designation List',
          url: '/designation-list',
          img: '',
          disable: ''
        },
        {
          label: 'FileNet',
          url: this.fileNetURL || '',
          img: require('@core/assets/admin/externalLink_Line.svg'),
          disable: isEmpty(this.fileNetURL)
        },
        {
          label: 'Intermediaries',
          url: '/payee-list',
          // img: require('@core/assets/admin/Intermediaries List.png')
          // img: require('@core/assets/admin/Intermediaries List.png')
        },
        {
          label: 'New Business Registry',
          url: '/policy-list',
          img: ''
        },
        {
          label: 'Product Master',
          url: '/admin-products',
          // img: require('@core/assets/admin/Product List.png')
        },
        {
          label: 'Product Provider',
          url: '/company-codes-list',
          // img: require('@core/assets/admin/Product Principal List.png')
        },
        // {
        //   label: 'Recruit',
        //   url: '/home-recruiter',
        //   img: ''
        // },
        {
          label: 'Qualification Setup',
          url: '/qualification-setup',
          img:'',
          disable: this.isQualificationSetupDisabled 
        },
        {
          label: 'Resources',
          url: '/resources',
          // img: require('@core/assets/admin/Resources.png'),
          disable: !this.projectSettings.useResourcesModule
        },
        {
          label: 'Scheduler',
          url: '/scheduler',
          subjects: ['scheduler']
          // img: require('@core/assets/admin/Intermediaries List.png')
        },
        {
          label: 'System Rights Administration',
          url: '/system-rights-administration',
          img: '',
          disable: this.currentUser.systemRole !== 'it-super-admin'
        },
        {
          label: 'User Administration',
          url: '/user-list',
          img:''
        },
        {
          label: 'Tenant Configuration',
          url: '/tenant-configuration',
          img:'',
          disable: this.isTenantConfigDisabled
        }
      ]
    const filteredMenu = menu.filter(item => this.canShowMenuForItem(ability, item));
    return filteredMenu
  }

  canShowMenuForItem(ability, item) {
    if (!item.subjects) return true; // no subject means always show

    const actionsToCheck = ['manage', 'write_all', 'read_all', 'read', 'read_others', 'write'];

    return item.subjects.some(subject =>
      actionsToCheck.some(action => {
        if (!ability.can(action, subject)) return false;
        // Now check if there is a rule with target 'all' or 'others' for this action and subject
        return ability.rules.some(rule =>
          rule.subject === subject &&
          rule.action === action &&
          (rule.target === 'all' || rule.target === 'others')
        );
      })
    );
}
}
</script>

<style lang="scss" scoped>
@import '@/design';

$window-height: 134vh;

.page {
  display: block;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 3rem;
  justify-items: center;
  align-content: center;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;

  a {
    text-decoration: none;
  }
  
  & > div.list {
    display: flex;
    width: 100%;
    justify-content: center;   
    justify-items: center;
  }

  ul.first-list  {
    border-left: 1px solid #EAEAEA;
    border-right: 1px solid #EAEAEA;
    width: 20%;
    height: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  ul.second-list {
    width: 20%;
    border-right: 1px solid #EAEAEA;
    margin-left: 0rem;
    height: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  ul.third-list {
    width: 20%;
    border-right: 1px solid #EAEAEA;
    margin-left: 0rem;
    height: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  ul > li {
    margin-bottom: 0;
  }

  .link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 0.75rem;
    width: 100%;
    padding: 16px;
    text-align: left;
    color: #707070;
    text-decoration: none !important;
    font-size: 14px;
    font-weight: 600;
    min-height: 45px;

    transition: background-color 0.3s ease, transform 0.3s ease, border-left-color 0.3s ease, color 0.3s ease;

    &:hover {
      cursor: pointer;
      transform: translateY(-1px);
      font-weight: 600 !important;
      color: $color-primary;
    }

    &  > span {
      font-weight: 500;
    }
  }
}

@media(min-width: 800px) {
  .page {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.selected-menu {
  background-color:#EAEAEA;
  border-left: 4px solid $color-primary;

  span {
    font-weight: 600 !important;
    color: $color-primary;
  }
}
</style>
